<template>
  <container :class="['page-wrapper']">
    <flex :spacing="3">
      <flex-col :span="24">
        <test-toolbar>
          <checkbox label-size="xs" :icon-color="$root.$colors.primary" :label="$lang.toolbar" :icon-color-lightness="$root.$colors.bgColorLightness" v-model="toolbar" /><!--
          --><checkbox label-size="xs" :icon-color="$root.$colors.primary" :label="$lang.readonly" :icon-color-lightness="$root.$colors.bgColorLightness" v-model="readonly" /><!--
          --><checkbox label-size="xs" :icon-color="$root.$colors.primary" :label="$lang.disabled" :icon-color-lightness="$root.$colors.bgColorLightness" v-model="disabled" /><!--
          --><checkbox label-size="xs" :icon-color="$root.$colors.primary" :label="$lang.spellCheck" :icon-color-lightness="$root.$colors.bgColorLightness" v-model="spellCheck" />
        </test-toolbar>
      </flex-col>
      <flex-col :span="24">
        <inline-editor @blur="onBlur" :readonly="readonly" :disabled="disabled" :toolbar="toolbar" :spell-check="spellCheck" :color-lightness="$root.$colors.bgColorLightness" :color="$root.$colors.primary" :class="['text-sm']">{{ text }}</inline-editor>
      </flex-col>
    </flex>
    <lorem-ipsum ref="lorem-ipsum" hidden />
  </container>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'PageInlineEditor',
  mixins: [
    methods
  ],
  data () {
    return {
      text: null,
      toolbar: false,
      spellCheck: true,
      readonly: false,
      disabled: false
    }
  },
  mounted () {
    this.getLoremIpsumRawContent(3)
  },
  methods: {
    onBlur ($event) {
      this.log('blur', 'inline-editor', $event)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/ui/inline-editor.vue